import React from "react";
import type { AvatarSize } from "@design-system/Avatar/Avatar";
import { UserSchema } from "@common/schemas/user.schema";
import { HStack } from "@design-system/HStack/HStack";
import { UserAvatar } from "@components/avatar/UserAvatar";

interface UserInfoProps {
    user: Pick<
        UserSchema,
        "name" | "avatar" | "iconColor" | "email" | "firstName" | "lastName"
    >;
    size?: AvatarSize;
}

/** A user's avatar followed by their name. */
export const UserInfo: React.FC<UserInfoProps> = ({ user, size = "lg" }) => (
    <HStack gap={8}>
        <UserAvatar user={user} size={size} aria-hidden />
        {user.name || `${user.firstName} ${user.lastName}`.trim()}
    </HStack>
);
